PegasusTemplate.CopyableView = Ember.Mixin.create({
  copyView: function(params){
    var copy = this.copy(true),
      props = params || {};

    props = $.extend( props, {
      controller: this.get('controller')
    });

    return copy.setProperties(props);
  }
});
